module.exports = __webpack_public_path__ + "static/media/contest2025_second_place_profileImage_small.1d6f5e92.jpeg";